import { Text } from "@octopusdeploy/design-system-components";
import { DebounceValue } from "../../../utils/DebounceValue";
import { UseLabelStrategy } from "../../../utils/LabelStrategy";
export const TextWithLabel = UseLabelStrategy(Text, (fieldName) => fieldName);
export const DebouncedTextWithLabel = DebounceValue(TextWithLabel);
